import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Tabs , Form, Divider, Button, message, Space, Skeleton} from 'antd';
import {procesarNomina, procesarNominaEmpleado, reciboDetalleNomina} from '../../../../apis/ProcesoNominaApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import Currency from '../../../../components/common/Currency';
import useCookies from "../../../../hooks/useCookies";
import {status_period} from '@app/constants/period';
import {clases} from '../../../../constants/tipoConcepto';
import FormBody from './form'
import _ from 'lodash'
import './slytes.scss';

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Procesar Nómina</span>
      </>
    ),
  }];

const ProcesarNomina = () => {
    const [empleadoCookie] = useCookies("empleado_id");
    const [ form ] = Form.useForm()
    const [ result, setResult ] = useState([]);
    const [ resultAcumulados, setResultAcumulados ] = useState([]);
    const [ resultConecepts, setResultConcepts ] = useState([]);
    const [ periodDetail, setPeriodDetail ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [periodData, setPeriodData] = useState(null);
    const [status, setStatus] = useState(null);
    const [header, setHeader] = useState(null);  
    const bodyRef = React.createRef();

     useEffect(() => {
          (async () => {
              if(result){
                var conceptos = result.filter(x => !x.acumulado?.id)
                var acumulados = result.filter(x => x.acumulado?.id > 0)
                const tipoOrder = { '1': 0, '2': 1, '5': 2 };
                conceptos.sort((a, b) => {
                  const orderA = tipoOrder[a.concepto?.tipo_concepto?.clase] ?? 99;
                  const orderB = tipoOrder[b.concepto?.tipo_concepto?.clase] ?? 99;
                  return orderA - orderB;
                });
                setResultConcepts(conceptos);
                setResultAcumulados(acumulados.sort((a, b) => a.concepto?.clave.localeCompare(b.concepto?.clave)));
              }
          })();
      }, [result]);

      useEffect(() => {
        (async () => {
            if(empleadoCookie?.value > 0){
              var _header = {...header, odoo_empleado_id: empleadoCookie?.value};
              setHeader(_header)
            }
        })();
    }, [empleadoCookie]);

    const handleOk = async ({concepto}) => {
      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
          ...fields
      }
      const response = await procesarNomina(payload);
      success = response.ok;
      if(response.ok){
          // setID(response.payload);
          message.success('Se guardo correctamente el movimiento!');
      }

      if(success){
        await resetBody();
      }
    }

    const handleOkEmpleado = async ({}) => {
      setLoading(true);
      try {
          const values = await form.validateFields();
          if(!values) return;
      } catch (errorInfo) {
          return;
      }

      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
          ...fields
      }
      const response = await procesarNominaEmpleado(payload);
      success = response.ok;
      setLoading(false);
      if(response.ok){
        clearData(response.payload)
        // setID(response.payload);
        message.success('Se proceso correctamente el movimiento!');
      }

      if(success){
        // await resetBody();
      }
    }

    const handleChangeEmpleado = async () => {
      try {
          const values = await form.validateFields();
          if(!values) return;
      } catch (errorInfo) {
          return;
      }

      setLoading(true);
      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
          ...fields
      }
      const response = await reciboDetalleNomina(payload.odoo_empleado_id, payload.periodo_id, payload.anio, payload.num_periodo );
      success = response.ok;
      if(response.ok){
        clearData(response.payload);
      }
      setLoading(false);
    }

    const clearData = (data) => {
      //1002 = deducciones
      const lines = data.filter(line =>  (line.dias > 0 || line.horas > 0 || line.exento > 0 || line.monto > 0) || line.concepto?.clave == '1002');
      setResult(lines)
    }
    
    const resetBody = async ()=>{
      let values = await form.getFieldValue();
      form.resetFields();
      form.setFieldsValue({
        periodo_id: values.periodo_id,
        anio: values.anio,
        num_periodo: values.num_periodo,
      });
    }

    const onBlurHeader = async (values, dataPeriod, status)=> {
      setHeader(values)
      if(values?.anio && values?.num_periodo && values?.periodo_id){
        setDisabled(false);
      }else{
        setDisabled(true);
      }
      setPeriodData(dataPeriod);
      setStatus(status?.value);
    }

    const getPeriodDetails = async (periodDetails)=> {
      setPeriodDetail(periodDetails);
    }

    const fmt2 = (item) => {
      if (item === null || item === undefined || item === '') return '';
      const n = Number(item);
      if (Number.isNaN(n) || n === 0) return '';
      return Math.abs(n).toFixed(2);
    };

    const renderMoney = (item) => {
      const v = fmt2(item);
      return v === '' ? '' : <Currency value={Number(v)} />;
    };

    const renderNum = (item) => {
      if (item === null || item === undefined || item === '') return '';
      const n = Math.abs(Number(item) || 0);
      if (n === 0) return '';
      return n.toFixed(2);
    };


    const columns = [
      {
        title: 'Tipo',
        dataIndex: 'concepto',
        key: 'concepto',
        render: (item, object)=> {
          if(object.concepto?.tipo_concepto?.descripcion)
            return object.concepto?.tipo_concepto?.descripcion;
          
          return ''
        }
      },
      {
        title: 'Concepto',
        dataIndex: 'concepto',
        key: 'concepto',
        render: (item, object)=> {
          if(object.concepto?.clave)
            return object.concepto?.clave;

          if(object.acumulado?.concepto?.clave)
            return object.acumulado?.concepto?.clave;

          return '';
        }
      },
      {
        title: 'Descripcion',
        dataIndex: 'concepto',
        key: 'concepto',
        render: (item, object)=> {
          if(object.concepto?.descripcion)
            return object.concepto?.descripcion;

          if(object.acumulado?.concepto?.descripcion)
            return object.acumulado?.concepto?.descripcion;

          return '';
        }
      },
      {
        title: 'Origen',
        dataIndex: 'tipo_movimiento',
        key: 'tipo_movimiento',
        render: (item, object)=> {
          return item || '';
        }
      },
      {
        title: 'Dias',
        dataIndex: 'dias',
        key: 'dias',
        align: 'right',
        render: renderNum,
      },
      {
        title: 'Exento',
        dataIndex: 'exento',
        key: 'exento',
        align: 'right',
        render: renderMoney,
      },
      {
        title: 'Horas',
        dataIndex: 'horas',
        key: 'horas',
        align: 'right',
        render: renderNum,
      },
      {
        title: 'Monto',
        dataIndex: 'monto',
        key: 'monto',
        align: 'right',
        render: renderMoney, 
      },
      {
        title: 'Saldo Anterior',
        dataIndex: 'saldo_anterior',
        key: 'saldo_anterior',
        align: 'right',
        render: renderMoney,
      },
      {
        title: 'Saldo Nuevo',
        dataIndex: 'saldo_nuevo',
        key: 'saldo_nuevo',
        align: 'right',
        render: renderMoney,
      },
    ];

    return <PageApp 
      routes={routes}
      title={'Procesar Nómina Individual'}>
          <AnioPeriodo onBlur={onBlurHeader} getPeriodDetails={getPeriodDetails} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
          {/* <Button type="primary" onClick={handleOk}>
              Procesar Todos
          </Button> */}
          <Divider/>
          {
            periodData && <FormBody header={header} ref={bodyRef} onOk={handleOkEmpleado} onChangeEmpleado={handleChangeEmpleado} form={form} disabledForm={disabledForm} disabledSubmit={status && (status > status_period.calculado_total)}/>
          }
          <Divider/>
          {
            loading ? <Skeleton active={loading} />: <>
              {
                result.length == 0 ? <Empty />:
                <Tabs
                  defaultActiveKey="1"
                  items={[
                    {
                      key: '1',
                      label: 'Recibo',
                      children: <Table dataSource={resultConecepts} columns={columns} pagination={false} />
                    },
                    {
                      key: '2',
                      label: 'Acumulados',
                      children: <Table dataSource={resultAcumulados} columns={columns} pagination={false} />
                    }
                  ]}
                />
                
              }
            </>
          }
    </PageApp>
}   

export default ProcesarNomina;
